// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import React from 'react'
import { object, oneOf, string } from 'prop-types'
import getSiteValues from './getSiteValues'
import RenderSiteCell from './RenderSiteCell'

// This component allows us to bold the site name when the assigned frequency plan
// is of pair designation HI

const PathSiteNames = ({ columnKey, idRoot, rowData }) => {
  const {
    site1Value: site1Name,
    site2Value: site2Name,
  } = getSiteValues(columnKey, rowData)

  const {
    site1Value: site1PairDesignation,
    site2Value: site2PairDesignation,
  } = getSiteValues('pairDesignation', rowData)

  const site1ClassName = (
    // NOTE - pair designation of HI hard coded here as H
    site1PairDesignation.toUpperCase() === 'H'
      ? 'font-weight-bold'
      : ''
  )

  const site2ClassName = (
    // NOTE - pair designation of HI hard coded here as H
    site2PairDesignation.toUpperCase() === 'H'
      ? 'font-weight-bold'
      : ''
  )

  return (
    <div className={'path-summary-cell'}>
      <RenderSiteCell
        className={site1ClassName}
        contents={site1Name}
        label={`site-1-${columnKey}`}
        id={`${idRoot}-site-1`} />
      <RenderSiteCell
        className={site2ClassName}
        contents={site2Name}
        label={`site-2-${columnKey}`}
        id={`${idRoot}-site-2`} />
    </div>
  )
}

PathSiteNames.propTypes = {
  columnKey: oneOf(['siteName']).isRequired,
  idRoot: string.isRequired,
  rowData: object.isRequired,
}

export default PathSiteNames
